// extracted by mini-css-extract-plugin
export default {"overlay":"nx-z","bodyOpen":"ox-z","content":"px-z","header":"qx-z","close":"rx-z","closeNoHeading":"sx-z"};